import { randomWholeNumberInRange } from '@utils/math';

export const hsl = (
    hue: number,
    saturation: number,
    lightness: number,
): string => `hsl(${hue}, ${saturation}%, ${lightness}%)`;

export const getRandomColor = (): string =>
    hsl(
        randomWholeNumberInRange(0, 36) * 10, // Random hue between 0 and 360 in interval of 10
        80,
        randomWholeNumberInRange(0, 10) + 50, // Random lightness between 50 and 60
    );
